import { VideoConfiguration } from '../../Components/ChimeVideoCall/meeting-call.types';

export enum MeetingStatus {
  Upcoming = 'upcoming',
  Ongoing = 'ongoing',
  Finished = 'finished',
}

export type Appointment = {
  acuityAppointmentTimezone: string;
  appointmentEndAt: string;
  appointmentStartAt: string;
  appointmentTypeName: string;
  coreAppointmentId: number;
  meetingStatus: MeetingStatus;
};

export type BaseParticipant = {
  id: number;
  name: string;
  uuid: string;
};

export type Participant = BaseParticipant & {
  authToken: string;
  clinicId?: number;
  userType: 'HOST' | 'ATTENDANT';
  connectedAt: string | null;
  joinedRoomAt: string | null;
};

export type HostParticipant = BaseParticipant & {
  connectedAt: string | null;
};

export type MeetingInformation = {
  appointment: Appointment;
  host: Participant;
  currentParticipant: Participant;
  participants: Participant[];
  pusherChannel: string;
};

export enum MeetingUserType {
  Host = 'HOST',
  Attendant = 'ATTENDANT',
}

export type JoinMeetingAsParticipantResponse = {
  role: MeetingUserType.Host;
  userType: MeetingUserType.Host;
  videoConfig: VideoConfiguration | null;
};
